const INSERT_INSTAGRAM_BUTTON = "insert-instagram-button";
const INSERT_TWITTER_BUTTON = "insert-twitter-button";
const INSERT_PINTEREST_BUTTON = "insert-pinterest-button";
const INSERT_FACEBOOK_BUTTON = "insert-facebook-button";
const INSERT_TIKTOK_BUTTON = "insert-tiktok-button";
const SOCIAL_EMBED_MODAL = "social-embed-upload-modal";
const SOCIAL_EMBED_MODAL_INPUT = "social-embed-upload-modal-input";
const SOCIAL_EMBED_MODAL_SUBMIT_BTN = "action-button-save";
const LINK_PREVIEW_VIEWER = "link-preview-viewer";
const PLUGIN_TOOLBAR_REPLACE_TO_LINK_BUTTON = "plugin-toolbar-replace-to-link-button";
const PLUGIN_TOOLBAR_UNLINK_BUTTON = "plugin-toolbar-unlink-button";
const SETTINGS_LINKPREVIEW_IMAGE_DISPLAY_TOGGLE = "settings-linkpreview-image-display-toggle";
const SETTINGS_LINKPREVIEW_IMAGE_POSITION_LEFT_THUMBNAIL = "settings-linkpreview-image-position-left-thumbnail";
const SETTINGS_LINKPREVIEW_IMAGE_POSITION_TOP_THUMBNAIL = "settings-linkpreview-image-position-top-thumbnail";
const SETTINGS_LINKPREVIEW_IMAGE_POSITION_RIGHT_THUMBNAIL = "settings-linkpreview-image-position-right-thumbnail";
const SETTINGS_LINKPREVIEW_TITLE_COLOR_PICKER_TRIGGER = "settings-linkpreview-title-color-picker-trigger";
const SETTINGS_LINKPREVIEW_SUBTITLE_COLOR_PICKER_TRIGGER = "settings-linkpreview-subtitle-color-picker-trigger";
const SETTINGS_LINKPREVIEW_LINK_COLOR_PICKER_TRIGGER = "settings-linkpreview-link-color-picker-trigger";
const SETTINGS_LINKPREVIEW_BACKGROUND_COLOR_INPUT = "settings-linkpreview-background-color-input";
const SETTINGS_LINKPREVIEW_BACKGROUND_COLOR_TRIGGER = "settings-linkpreview-background-color-trigger";
const SETTINGS_LINKPREVIEW_BORDER_COLOR_INPUT = "settings-linkpreview-border-color-input";
const SETTINGS_LINKPREVIEW_BORDER_COLOR_TRIGGER = "settings-linkpreview-border-color-trigger";
const SETTINGS_LINKPREVIEW_BORDER_WIDTH_INPUT = "settings-linkpreview-border-width-input";
const SETTINGS_LINKPREVIEW_CORNER_RADIUS_INPUT = "settings-linkpreview-corner-radius-input";
const SETTINGS_LINKPREVIEW_TABS = "settings-linkpreview-tabs";
const SETTINGS_LINKPREVIEW_MODAL = "settings-linkpreview-modal";
export {
  INSERT_FACEBOOK_BUTTON,
  INSERT_INSTAGRAM_BUTTON,
  INSERT_PINTEREST_BUTTON,
  INSERT_TIKTOK_BUTTON,
  INSERT_TWITTER_BUTTON,
  LINK_PREVIEW_VIEWER,
  PLUGIN_TOOLBAR_REPLACE_TO_LINK_BUTTON,
  PLUGIN_TOOLBAR_UNLINK_BUTTON,
  SETTINGS_LINKPREVIEW_BACKGROUND_COLOR_INPUT,
  SETTINGS_LINKPREVIEW_BACKGROUND_COLOR_TRIGGER,
  SETTINGS_LINKPREVIEW_BORDER_COLOR_INPUT,
  SETTINGS_LINKPREVIEW_BORDER_COLOR_TRIGGER,
  SETTINGS_LINKPREVIEW_BORDER_WIDTH_INPUT,
  SETTINGS_LINKPREVIEW_CORNER_RADIUS_INPUT,
  SETTINGS_LINKPREVIEW_IMAGE_DISPLAY_TOGGLE,
  SETTINGS_LINKPREVIEW_IMAGE_POSITION_LEFT_THUMBNAIL,
  SETTINGS_LINKPREVIEW_IMAGE_POSITION_RIGHT_THUMBNAIL,
  SETTINGS_LINKPREVIEW_IMAGE_POSITION_TOP_THUMBNAIL,
  SETTINGS_LINKPREVIEW_LINK_COLOR_PICKER_TRIGGER,
  SETTINGS_LINKPREVIEW_MODAL,
  SETTINGS_LINKPREVIEW_SUBTITLE_COLOR_PICKER_TRIGGER,
  SETTINGS_LINKPREVIEW_TABS,
  SETTINGS_LINKPREVIEW_TITLE_COLOR_PICKER_TRIGGER,
  SOCIAL_EMBED_MODAL,
  SOCIAL_EMBED_MODAL_INPUT,
  SOCIAL_EMBED_MODAL_SUBMIT_BTN
};
//# sourceMappingURL=data-hooks.js.map
